import { Avatar, Card, Col, Progress } from "antd";
import { GetDealType } from "../../ducks/types";
import dayjs from "dayjs";
import {
  BILLING_MODAL,
  getInitials,
  NET_TERMS,
  PRICING_MODAL,
  SALE_TYPE,
} from "../../../../config/utils";

interface PropsType {
  sidebarData: GetDealType | null;
}

export default function DealsSidebar(props: PropsType) {
  const { sidebarData } = props;
  console.log("sidebarData", sidebarData);
  return (
    <Col flex="360px" className="right_area">
      <Card className="right_cards">
        <h6> General details </h6>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            marginBottom: "12px",
          }}
        >
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle">Responsible manager</h6>
            <h6 className="miniDetail">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {sidebarData?.manager_image_url ? (
                  <Avatar src={sidebarData?.manager_image_url} size={24} />
                ) : (
                  sidebarData?.manager_name && (
                    <Avatar size={24}>
                      {getInitials(sidebarData?.manager_name, "")}
                    </Avatar>
                  )
                )}
                {sidebarData?.manager_name ? sidebarData?.manager_name : "-"}
              </div>
            </h6>
          </div>
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle">Type of sale</h6>
            <h6 className="miniDetail">
              {sidebarData?.sale_type
                ? SALE_TYPE[sidebarData?.sale_type as keyof typeof SALE_TYPE]
                : "-"}
            </h6>
          </div>
        </div>

        <div>
          <h6
            className="miniTitle"
            style={{ margin: "0 0 8px 0", paddingTop: 4 }}
          >
            Probability:
          </h6>
          <Progress
            strokeColor="#00A07D"
            percent={sidebarData?.probability}
            size={["100%", 7]}
          />
        </div>
      </Card>
      <Card className="right_cards">
        <h6> Contract terms </h6>
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle"> Start date </h6>
            <h6 className="miniDetail">
              {sidebarData?.start_date
                ? dayjs(sidebarData?.start_date).format("ll")
                : "-"}
            </h6>
          </div>
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle"> End date </h6>
            <h6 className="miniDetail">
              {sidebarData?.end_date
                ? dayjs(sidebarData?.end_date).format("ll")
                : "-"}
            </h6>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle"> Renewable </h6>
            <h6 className="miniDetail">
              {sidebarData?.renewable ? "Yes" : "No"}
            </h6>
          </div>
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle"> Pricing model </h6>
            <h6 className="miniDetail">
              {sidebarData?.pricing_model
                ? PRICING_MODAL[
                    sidebarData?.pricing_model as keyof typeof PRICING_MODAL
                  ]
                : "-"}
            </h6>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
          }}
        >
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle"> Billing </h6>
            <h6 className="miniDetail">
              {sidebarData?.billing
                ? BILLING_MODAL[
                    sidebarData?.billing as keyof typeof BILLING_MODAL
                  ]
                : "-"}
            </h6>
          </div>
          <div style={{ width: "45%" }}>
            <h6 className="miniTitle"> Net terms </h6>
            <h6 className="miniDetail">
              {sidebarData?.net_terms
                ? NET_TERMS[sidebarData?.net_terms as keyof typeof NET_TERMS]
                : "-"}
            </h6>
          </div>
        </div>
      </Card>
    </Col>
  );
}
